const translations = {
  "en": {
    "Annual": "Annual",
    "EPS": "EPS",
    "Quarterly": "Quarterly",
    "Revenue": "Revenue"
  },
  "zh-tw": {
    "Annual": "年度",
    "EPS": "EPS",
    "Quarterly": "每季",
    "Revenue": "收入"
  }
};

export default translations;
